import React, { useState, useEffect } from 'react';
import api from '../api/api';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import ToastMessage from '../utils/muitoast';


const AddDeviceModal = ({ isOpen, onClose, deviceData, onSave,showToast }) => {
  const [formData, setFormData] = useState({
    deviceName: '',
     deviceId: '',
    uid: '',
    
    status: 'Active'
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const token = sessionStorage.getItem("accessToken");  
 const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  
  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  useEffect(() => {
    if (deviceData) {
      setFormData({
        deviceName: deviceData.device_name?.trim() || '',
          deviceId: String(deviceData.serial_id|| ''),
        uid: String(deviceData.device_uid).trim() || '',
        status: deviceData.status === 'A' ? 'Active' : 'Inactive'
      });
    } else {
      setFormData({
        deviceName: '',
         deviceId: '',
        uid: '',
        status: 'Active'
      });
    }
    setErrors({});

  }, [deviceData, isOpen]);

  const validateForm = () => {
    const newErrors = {};
      const isEditMode = !!deviceData?.device_id;
    if (!formData.deviceName.trim()) {
      newErrors.deviceName = 'Device name is required';
    }
  if (!isEditMode && !formData.deviceId.trim()) {
    newErrors.deviceId = 'Device ID is required';
  }
    
   if (!formData.uid.trim()) {
  newErrors.uid = 'Device UID is required';
} else if (!/^[a-zA-Z0-9_ ]+$/.test(formData.uid)) {
  newErrors.uid = 'UID must be alphanumeric (spaces and underscores allowed)';
}

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // Clear error when field is edited
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
  
    setIsLoading(true);

  
    try {
      const devicePayload = {
        device_id: deviceData?.device_id || 0,
        device_name: formData.deviceName,
        device_uid: formData.uid,
    serial_id : formData.deviceId,
        status: formData.status === 'Active' ? 'A' : 'I'
      };
      
  
      let response;
      const isEditMode = !!deviceData?.device_id;

      if (isEditMode) {
        response = await api.put('/v1/device/update', devicePayload, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
      } else {
        response = await api.post("/v1/device/create", devicePayload, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
      }
      if(response.status==200){
 setSeverity("success");
      setAlertMessage( response?.data?.message || 
        (isEditMode ? 'Device updated successfully' : 'Device created successfully'));
      setOpen(true);
    
      onSave(response?.data, isEditMode);
            onClose();
      }else{
 setSeverity("info");
      setAlertMessage( response?.data?.message || 'Something Went Wrong');
      setOpen(true);
      }
     
    } catch (err) {
      console.error("Error saving device:", err);
      setSeverity("error");
      setAlertMessage('Something Went Wrong');
      setOpen(true);

    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50'>
      <div className='bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative'>
        <h2 className='text-xl text-red-800 text-left font-Font1 font-semibold mb-4'>
          {deviceData ? 'Edit Device' : 'Add New Device'}
        </h2>


        <form onSubmit={handleSubmit} className='border-t pt-4'>
          <div className='space-y-4 font-inter'>
            <div>
              <label className='flex font-Font1 text-red-800 text-[15px]'>Device Name *</label>
              <input
                name="deviceName"
                className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${
                  errors.deviceName ? 'border-red-500' : ''
                }`}
                value={formData.deviceName}
                onChange={handleChange}
                placeholder='Device Name'
              />
              {errors.deviceName && (
                <p className="text-red-500 text-xs mt-1">{errors.deviceName}</p>
              )}
            </div>
<div>
  <label className='flex font-Font1 text-red-800 text-[15px]'>Device ID *</label>
  <input
    name="deviceId"
    className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${
      errors.deviceId ? 'border-red-500' : ''
    }`}
    value={formData.deviceId}
    onChange={handleChange}
    placeholder="Device ID"

  />

  {errors.deviceId && (
    <p className="text-red-500 text-xs mt-1">{errors.deviceId}</p>
  )}
</div>
 <div>
  <label className='flex font-Font1 text-red-800 text-[15px]'>Device UID *</label>

  {deviceData ? (
    // Edit Mode — regular input
    <input
      name="uid"
      className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${
        errors.uid ? 'border-red-500' : ''
      }`}
      value={formData.uid}
      onChange={handleChange}
      placeholder='UID'
    />
  ) : (
    // Add Mode — prefix "iPad" + digits only
    <div className="flex">
      <span className="inline-flex items-center px-3 rounded-l border border-r-0 bg-gray-100 text-gray-700 text-sm">
        Ipad
      </span>
      <input
        name="uid"
        type="text"
        className={`w-full border rounded-r px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${
          errors.uid ? 'border-red-500' : ''
        }`}
        value={formData.uid.replace(/^Ipad/, '')}
        onChange={(e) => {
          const onlyDigits = e.target.value.replace(/\D/g, ''); // digits only
          setFormData(prev => ({ ...prev, uid: `Ipad${onlyDigits}` }));

          if (errors.uid) {
            setErrors(prev => ({ ...prev, uid: '' }));
          }
        }}
        placeholder="123"
      />
    </div>
  )}

  {errors.uid && (
    <p className="text-red-500 text-xs mt-1">{errors.uid}</p>
  )}
</div>


            <div>
              <label className='flex font-Font1 text-red-800 text-[15px]'>Status</label>
              <select
                name="status"
                className='w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none'
                value={formData.status}
                onChange={handleChange}
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>

          <div className='mt-6 text-right space-x-3'>
            {/* <button
              type="button"
              className='bg-gray-300 text-gray-800 px-6 py-2 rounded hover:bg-gray-400'
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button> */}
            <button
              type="submit"
              className='bg-red-800 text-white font-Font1 text-[14px] px-6 py-2 rounded  disabled:bg-gray-400'
              disabled={isLoading}
            >
              {isLoading ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>

        <button
          className='absolute top-4 right-4 text-gray-500 hover:text-black text-xl'
          onClick={onClose}
          disabled={isLoading}
        >
          <ClearRoundedIcon/>
        </button>
      </div>
       <ToastMessage
              message={alertMessage}
              severity={severity}
              open={open}
              handleClose={handleCloseToast}
            />
    </div>
  );
};

export default AddDeviceModal;